<span class="description">
  {{ title | translate }}
</span>
<automata-automation-replacement-chips
  label="AUTOMATIONS.COMMON.LIST"
  [dataService]="listService"
  [formControl]="listNameControl"
  [isRequired]="!isTemplateContext"
  [multiple]="false"
  [supportDataPassing]="false"
  (finishedInitialLoading)="finishedLoadingSelector()"
></automata-automation-replacement-chips>
